import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ps-lg-10 h-100 d-flex flex-column justify-content-evenly pb-lg-11" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-4 mb-2 text-center" }, "Légende des facteurs", -1)
const _hoisted_3 = { class: "fs-5 fw-bolder text-black col-2 pe-3" }
const _hoisted_4 = { class: "fs-6 fw-bolder text-gray-600 col-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.factors, (factor) => {
      return (_openBlock(), _createElementBlock("div", {
        key: factor.id,
        class: "mb-0 d-flex"
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(factor.number), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(factor.short_title), 1)
      ]))
    }), 128))
  ]))
}